import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { UltiService } from '__services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  apiUrl: string = environment.providers.api.url;

  constructor(
    public http: HttpClient,
    public ultiservice: UltiService
  ) {}

  public _addStandardHeaders(header: HttpHeaders): HttpHeaders {
    header = header.append('Content-Type', 'application/json');
    header = header.append('Accept', 'application/json');
    header = header.append('Access-Control-Allow-Methods', 'GET, POST, DELETE, PUT');
    return header;
  }

  get(endpoint: string, params?: any, reqOpts?: any): Observable<any> {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }
    if (params) {
      reqOpts.params = new HttpParams();
      for (const [key, value] of Object.entries(params)) {
        if (typeof value === 'object') {
          if (Array.isArray(value)) {
            for (const order of value) {
              reqOpts.params = reqOpts.params.append(key, order);
            }
          } else {
            reqOpts.params = reqOpts.params.set(key, JSON.stringify(value));
          }
        } else {
          reqOpts.params = reqOpts.params.set(key, value);
        }
      }
    }
    return this.http.get(this.apiUrl + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any): Observable<any> {
    body = this.ultiservice.trimStrings(body);
    return this.http.post<any>(this.apiUrl + endpoint, body, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any): Observable<any> {
    body = this.ultiservice.trimStrings(body);
    return this.http.put(this.apiUrl + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any): Observable<any> {
    return this.http.delete(this.apiUrl + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any): Observable<any> {
    body = this.ultiservice.trimStrings(body);
    return this.http.patch(this.apiUrl + endpoint, body, reqOpts);
  }
}
